import styled, {css} from 'styled-components'

export const StyledClinicalPresentationCardFormFieldGrid = styled.div(
    () => css`
        display: grid;
        grid-template-columns: 240px auto;
        align-items: center;
    `
)
